import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { VariableBenefitSummary } from '../../../../../../models/submissions/variable-benefit-summary';
import { VbRecurringPaymentInstructionCard } from '../../interfaces/vb-recurring-payment-instruction-card';
import { VbRecurringPaymentInstructionUtils } from '../../utils/vb-recurring-payment-instruction.utils';

@Component({
  selector: 'app-vb-payment-change-recurring-payments',
  templateUrl: './vb-payment-change-recurring-payments.component.html',
  styleUrls: ['./vb-payment-change-recurring-payments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeRecurringPaymentsComponent implements OnChanges {
  @Input({ required: true }) summary!: VariableBenefitSummary;

  public cards: VbRecurringPaymentInstructionCard[] = [];

  public ngOnChanges(): void {
    this.cards = VbRecurringPaymentInstructionUtils.toCards(this.summary);
  }

  public trackByIndex(index: number): number {
    return index;
  }
}
